import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import colors from "../theme/colors";

// Carte d'information de la fiche réservation.
// En-tête (icône + titre bleu charte + séparateur) puis contenu aligné à gauche.
// Le survol (élévation) est géré par la classe CSS .info-card (index.css),
// PAS par Radium :hover (incompatible React 18).
function InfoCard({ icon, title, titleRight, children, style }) {
  return (
    <div
      className="info-card"
      style={{
        width: "100%",
        boxSizing: "border-box",
        backgroundColor: colors.white,
        border: `1px solid ${colors.border}`,
        borderRadius: 12,
        boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 8px 20px rgba(0,0,0,0.06)",
        padding: 11,
        ...style,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 6,
          rowGap: 4,
          paddingBottom: 6,
          marginBottom: 8,
          borderBottom: `1px solid ${colors.border}`,
        }}
      >
        {icon && (
          <FontAwesomeIcon icon={icon} style={{ color: colors.brand, fontSize: 12 }} />
        )}
        <span style={{ color: colors.brand, fontWeight: 700, fontSize: 13, flex: 1 }}>
          {title}
        </span>
        {titleRight}
      </div>
      <div
        style={{
          fontSize: 12.5,
          color: colors.text,
          lineHeight: 1.4,
          overflowWrap: "anywhere",
          wordBreak: "break-word",
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default InfoCard;
